import { BrowserRouter,Route,Routes } from "react-router-dom";
import Mines from "./pages/mines/Mines";
function App() {
  return (
    <div className="App">
     <BrowserRouter>
        <Routes>
          <Route path="/" element={<Mines />} />
        </Routes>
     </BrowserRouter>
    </div>
  );
}

export default App;
